import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';


class ServiceSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ServiceList: [{
                "icon": "mdi mdi-database",
                "title": "Citas",
                "content": "Reserva de citas de vía web o WhatsApp.\nArribo al patio mediante alerta GPS\nMensaje de alerta electrónico si falta algún documento",
            }, {
                "icon": "mdi mdi-palette",
                "title": "Inspección",
                "content": "Inspección electrónica con reconocimiento de imagen envío reporte automático.",
            }, {
                "icon": "mdi mdi-finance",
                "title": "Reparación",
                "content": "Documentación y captura digital de fotografía e inspección electrónica.",
            }, {
                "icon": "mdi mdi-yin-yang",
                "title": "Almacenaje",
                "content": "Comunicación y monitoreo en tiempo real de cada paso dentro del patio con pasabordo QR.",
            }, {
                "icon": "mdi mdi-apple-keyboard-command",
                "title": "Reposiciones",
                "content": "Identificación anticipada de reposiciones express y 'StreetTurn'.",
            }, {
                "icon": "mdi mdi-hexagon-multiple",
                "title": "Tecnología",
                "content": "Cronómetro en vivo de la permanencia del camión en cada paso: tiempo en la fila, en el cargue/descargue y a la salida.",
            },
            ]
        };
    }

    render() {

        return (
            <React.Fragment>
                <section className="section" id="services">
                    <div className="container">
                        <Row>
                            <Col lg="12">
                                <div className="title-heading mb-5">
                                    <h3 className="text-dark mb-1 font-weight-light text-uppercase">Nuestros Servicios</h3>
                                    <div className="title-border-simple position-relative"></div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            {this.state.ServiceList.map((service, index) => {
                                return <Col lg="4" md="6" key={index}>
                                    <div className="service-box rounded mt-4 p-4">
                                        <div className="service-icon mb-3">
                                            <i className={service.icon}></i>
                                        </div>
                                        <div className="services-desc">
                                            <div className="service-title mb-2 position-relative">
                                                <h5 className="font-weight-normal mb-3"><Link to="#" className="text-dark">{service.title}</Link></h5>
                                            </div>
                                            <p className="text-muted mb-3 f-14">{service.content}</p>
                                            <p style={{display : 'none'}} className="mb-0 text-uppercase f-13"><Link to="/" className="text-primary">más detalles<i className="mdi mdi-arrow-right ml-2"></i></Link></p>
                                        </div>
                                    </div>
                                </Col>
                            })}
                        </Row>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}
export default ServiceSection;